import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ee49fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-4" }
const _hoisted_5 = { class: "card-wrap" }
const _hoisted_6 = { class: "p-3 d-flex flex-column justify-content-center align-content-center" }
const _hoisted_7 = { class: "h4 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("news")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_card, {
        class: "m-3 p-0",
        style: {"width":"250px","height":"230px"},
        "body-style": { padding: '0px', width: '100%', height:'100%'},
        onClick: _ctx.onCardClicked
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t("sinbon_academy")), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}